import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nl2br'
})

export class nl2brPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return value;
        }
        else{
            // return value.replace(/(&nbsp;)/, ' ');
            return value.replace(/&nbsp;/g, ' ').replace(/\<br\s*[\/]?>/gi, '\n');
        }
 }
}